import React from "react";
import Update from "modules/formTemplates/components/Update";

const FormTemplateUpdatePage = () => {
  return <Update />;
};

export default FormTemplateUpdatePage;
